//#region Util Imports

import * as _ from 'underscore'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'

//#endregion

//#region IMR Imports

import { IMRTagBoxOptions, IMRTagBoxDropDownDirection } from '@imr/controls.angularjs/components/tag-box';

//#endregion


import { GoAlarmDef } from "../../interfaces/alarm-definitions-edit.interfaces"
import { Enums } from "../../../../../../models/common"
import { ColumnModel } from "../../../../../api/api.models"
import { LocalizationHelper, LogHelper, TypeHelper, ToastHelper } from "../../../../../../helpers"
import { OpAlarmDef, OpAlarmGroup, OpAlarmDefGroup, OpDataType, OpAlarmType } from "../../../../../../models/core"
import { AlarmDefinitionItemEditOptions, IAlarmDefinitionItemEdit } from "../../../alarm-definition-item-edit/alarm-definition-item-edit.interfaces"
import { IAlarmDefinitionGroupRowEditOptions, IAlarmDefinitionGroupRowEdit } from "../../../alarm-definition-group-row-edit/alarm-definition-group-row-edit.interfaces"
import { AlarmDefinitionService } from '../../../../../../services/alarm-definition'

export class AlartDefinitionsEditCommonController {

    // #region Consts

    protected get ALARM_DEF_SELECT_TITLE_TEXT(): string { return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AlarmDefSelectTitle) }
    protected get ALARM_DEF_SELECT_TYPE_TEXT(): string { return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AlarmDefSelectType) }
    protected get ALARM_DEF_REF_TYPE_TEXT(): string { return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AlarmDefRefType) }
    protected get ALARM_DEF_REF_VALUE_TEXT(): string { return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AlarmDefRefValue) }
    protected get ACTIVE_TEXT(): string { return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Active) }
    protected get SMS_TEXT(): string { return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Sms) }
    protected get EMAIL_TEXT(): string { return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Email) }
    protected get ALARM_DEF_ADD_TEXT(): string { return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AlarmDefAdd) }
    protected get ACCEPT_DEFS_TEXT(): string { return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AcceptDefs) }
    protected get SET_DEFINITION_NAME_TEXT(): string { return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SetDefinitionName) }
    protected alarmDefAddId: string = 'alarmDefAdd_' + TypeHelper.guid()

    // #endregion

    protected addAlarmDefButtonOptions: DevExpress.ui.dxButtonOptions
    protected alarmDefinitionsContainerScrollView: DevExpress.ui.dxScrollView
    protected alarmDefinitionsContainerScrollViewOptions: DevExpress.ui.dxScrollViewOptions
    protected alarmDefRefParams: ColumnModel[]
    protected alarmDefParamsColumns: ColumnModel[]
    protected alarmDefItemEditControllers: IAlarmDefinitionItemEdit[]
    protected alarmDefParamsExist: boolean
    protected alarmDefPopoverButtonOptions: DevExpress.ui.dxButtonOptions
    protected alarmDefPopoverOptions: DevExpress.ui.dxPopoverOptions
    protected alarmDefPopoverInputWidth: number
    protected alarmDefPopoverVisible: boolean
    protected alarmDefsOptions: AlarmDefinitionItemEditOptions[]
    protected alarmGroupEditOptions: IAlarmDefinitionGroupRowEditOptions[]
    protected alarmGroups: OpAlarmGroup[]
    protected alarmGroupEditControllers: IAlarmDefinitionGroupRowEdit[]
    protected alarmGroupsContainerScrollView: DevExpress.ui.dxScrollView
    protected alarmGroupsContainerScrollViewOptions: DevExpress.ui.dxScrollViewOptions
    protected alarmGroupsHeaderContainerScrollViewOptions: DevExpress.ui.dxScrollViewOptions
    protected alarmGroupsPossibleToAdd: OpAlarmGroup[]
    protected alarmTypes: OpAlarmType[]
    protected currentAlarmDefs: GoAlarmDef[]
    protected currentAlarmGroups: OpAlarmGroup[]
    protected dataTypes: OpDataType[]
    protected isSaveEnabled: boolean
    protected isSendToReferenceObjectEnabled: boolean
    protected selectedAlarmDefs: GoAlarmDef[]
    protected templateAlarmDefs: GoAlarmDef[]

    private alarmGroupsHeaderContainerScrollView: DevExpress.ui.dxScrollView

    constructor(
        protected alarmDefinitionService: AlarmDefinitionService) {
    }

    protected initializeCommon(): void {
        this.InitializeAlarmDefPopover()
        this.initializeAlarmDefTagBox()
    }

    protected setAlarmDefs(alarmDefs: OpAlarmDef[]): void {
        alarmDefs = _.map(alarmDefs, (alarmDef: OpAlarmDef) => alarmDef.clone(true, true, true, true))

        const allIdAlarmGroupsFromAlarmDefs: number[] = []
        const existingAlarmDefs: OpAlarmDef[] = []
        const templateAlarmDefs: GoAlarmDef[] = []
        const currentAlarmGroups: OpAlarmGroup[] = []

        alarmDefs.forEach((alarmDef: OpAlarmDef) => {
            if (alarmDef.currentAlarmDefGroups == null) {
                alarmDef.currentAlarmDefGroups = []
            }

            if (this.alarmDefinitionService.isAlarmDefTemplate(alarmDef)) {
                const template: GoAlarmDef = new GoAlarmDef(alarmDef)
                template.isTemplate = true
                templateAlarmDefs.push(template)
            } else {
                existingAlarmDefs.push(alarmDef)
            }

            alarmDef.currentAlarmDefGroups.forEach((alarmDefGroup: OpAlarmDefGroup) => {
                if (_.find(allIdAlarmGroupsFromAlarmDefs, (idAlarmGroup: number) => idAlarmGroup === alarmDefGroup.idAlarmGroup) == null) {
                    allIdAlarmGroupsFromAlarmDefs.push(alarmDefGroup.idAlarmGroup)
                    currentAlarmGroups.push(alarmDefGroup.alarmGroup)
                }
            })
        })

        this.currentAlarmDefs = existingAlarmDefs.map((alarmDef: OpAlarmDef) => new GoAlarmDef(alarmDef))
        this.templateAlarmDefs = templateAlarmDefs
        this.currentAlarmGroups = currentAlarmGroups

        if (this.currentAlarmDefs.length == 0) {
            this.currentAlarmDefs = this.templateAlarmDefs.map((template: GoAlarmDef) => {
                const alarmDef: GoAlarmDef = template.clone(true, true, true, true)

                alarmDef.opState = Enums.OpChangeState.New

                return alarmDef
            })

            // Wczytalismy alarmdefy z szablonu więc musimy włączyć zapis
            this.setButtonsStates()
        }

        this.alarmGroupsPossibleToAdd = _.sortBy(
            (this.alarmGroups || []).filter((alarmGroup: OpAlarmGroup) => _.find(allIdAlarmGroupsFromAlarmDefs, (idAlarmGroupFromDef: number) => alarmGroup.idAlarmGroup == idAlarmGroupFromDef) == null),
            (alarmGroup: OpAlarmGroup) => alarmGroup.name
        )

        this.alarmGroupEditControllers = []

        const alarmDefOptions: AlarmDefinitionItemEditOptions[] = []
        const alarmGroupEditOptions: IAlarmDefinitionGroupRowEditOptions[] = []

        this.currentAlarmDefs.forEach((alarmDef: GoAlarmDef) => {
            alarmDefOptions.push(this.createAlarmDefOptions(alarmDef))
            alarmGroupEditOptions.push(this.createAlarmGroupRowEditOptions(alarmDef.alarmDef))
        })

        this.alarmDefsOptions = alarmDefOptions
        this.alarmGroupEditOptions = alarmGroupEditOptions
        this.alarmDefItemEditControllers = []
        this.alarmGroupEditControllers = []
    }

    //#region options

    protected setCommonOptions(): void {
        this.alarmDefinitionsContainerScrollViewOptions = {
            direction: 'vertical',
            showScrollbar: 'never',
            height: '100%',
            onInitialized: (args: any) => { this.onAlarmDefinitionsContainerScrollViewInitialized(args) },
            onScroll: (args: any) => { this.onAlarmDefinitionsContainerScrollViewScroll(args) }
        }

        this.alarmDefPopoverButtonOptions = {
            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Add),
            onClick: (args: any) => { this.onAlarmDefPopoverButtonClick(args) }
        }

        this.alarmGroupsHeaderContainerScrollViewOptions = {
            direction: 'horizontal',
            showScrollbar: 'never',
            width: 'auto',
            height: 60,
            onInitialized: (args: any) => { this.onAlarmGroupsHeaderContainerScrollViewInitialized(args) },
            onScroll: (args: any) => { this.onAlarmGroupsHeaderContainerScrollViewScroll(args) }
        }

        this.alarmGroupsContainerScrollViewOptions = {
            direction: 'both',
            width: 'auto',
            height: '100%',
            onInitialized: (args: any) => { this.onAlarmGroupsContainerScrollViewInitialized(args) },
            onScroll: (args: any) => { this.onAlarmGroupsContainerScrollViewScroll(args) }
        }

        this.addAlarmDefButtonOptions = {
            icon: 'plus',
            onClick: (args: any) => { this.onAddAlarmDefClick(args) }
        }
    }

    private InitializeAlarmDefPopover(): void {
        this.alarmDefPopoverOptions = {
            width: 'auto',
            target: '#' + this.alarmDefAddId,
            visible: true,
            onHidden: () => { this.onAlarmGroupPopoverHidden() }
        }
    }

    protected createAlarmGroupRowEditOptions(alarmDef: OpAlarmDef): IAlarmDefinitionGroupRowEditOptions {
        return {
            alarmDef: alarmDef,
            alarmGroups: this.currentAlarmGroups,
            onInitialized: (controller: IAlarmDefinitionGroupRowEdit) => {
                this.alarmGroupEditControllers.push(controller)
                controller.repaint()
            },
            onAlarmDefUpdated: (controller: IAlarmDefinitionGroupRowEdit) => {
                this.setButtonsStates()
                this.setAlarmDefChangeState(alarmDef)
            }
        }
    }

    protected setButtonsStates(): void {
        this.isSendToReferenceObjectEnabled = false
        this.isSaveEnabled = true
    }

    protected setInitialButtonStats(): void {
        this.isSendToReferenceObjectEnabled = false
        this.isSaveEnabled = false
    }

    //#endregion

    //$region Events

    private onAlarmDefinitionsContainerScrollViewInitialized(args: any): void {
        this.alarmDefinitionsContainerScrollView = args.component
    }

    private onAlarmDefinitionsContainerScrollViewScroll(args: any): void {
        if (this.alarmGroupsContainerScrollView != null) {
            this.alarmGroupsContainerScrollView.scrollTo({ top: args.scrollOffset.top })
        }
    }

    private onAlarmGroupsHeaderContainerScrollViewInitialized(args: any): void {
        this.alarmGroupsHeaderContainerScrollView = args.component
    }

    private onAlarmGroupsHeaderContainerScrollViewScroll(args: any): void {

    }

    private onAlarmGroupsContainerScrollViewInitialized(args: any): void {
        this.alarmGroupsContainerScrollView = args.component
    }

    private onAlarmGroupsContainerScrollViewScroll(args: any): void {
        this.alarmDefinitionsContainerScrollView.scrollTo({ top: args.scrollOffset.top })
        this.alarmGroupsHeaderContainerScrollView.scrollTo({ left: args.scrollOffset.left })
    }

    protected onAlarmDefUpdated(alarmDef: GoAlarmDef): void {
        if (alarmDef.idAlarmDef == 0 && alarmDef.opState == Enums.OpChangeState.Delete) {
            this.deleteAlarmDef(alarmDef)
        } else {
            this.setButtonsStates()
        }
    }

    protected onAlarmGroupPopoverHidden(): void {
        this.clearNewAlarmDefCustomNames()
    }

    private onAlarmDefPopoverInputTagBoxCustomItemCreating(args: any): GoAlarmDef {
        if (args == null
            || args.component == null
            || TypeHelper.isNullOrEmpty(args.text)
        ) {
            return null
        }

        const dataSourceField: string = 'dataSource'
        const valueField: string = 'value'

        const component: any = args.component

        const newAlarmDef: GoAlarmDef = new GoAlarmDef(new OpAlarmDef(null))
        newAlarmDef.name = args.text

        const currentAlarmDefs: GoAlarmDef[] = component.option(dataSourceField)
        const existingAlarmDef: GoAlarmDef = _.find(currentAlarmDefs, (alarmDef: GoAlarmDef) => alarmDef.name === newAlarmDef.name)

        if (existingAlarmDef == null) {
            currentAlarmDefs.unshift(newAlarmDef)

            component.option(dataSourceField, currentAlarmDefs)

            // Tutaj jest OpAlarmDef bo valueExpr wskazuje na GoAlarmDef.alarmDef
            const selectedValues: OpAlarmDef[] = component.option(valueField) || []

            selectedValues.push(newAlarmDef.alarmDef)

            component.option(valueField, selectedValues)

            return newAlarmDef
        }

        return null
    }

    private onAlarmDefPopoverInputTagBoxValueChanged(args: any): void {
        if (args != null) {
            this.selectedAlarmDefs = args.value
        }
    }

    private onAlarmDefPopoverButtonClick(args: any): void {
        if (this.selectedAlarmDefs == null || this.selectedAlarmDefs.length == 0) {
            return
        }

        this.selectedAlarmDefs.forEach((selectedAlarmDef: GoAlarmDef) => {
            const nameAlreadyExists: boolean = this.currentAlarmDefs.some((alarmDef: GoAlarmDef) => {
                return alarmDef.name == selectedAlarmDef.name
                    && alarmDef.idAlarmDef != 0
            })

            if (nameAlreadyExists) {
                ToastHelper.showError(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.DefExists, { collection: 'Popup' }))
            } else if (TypeHelper.isNullOrEmpty(selectedAlarmDef.name) || TypeHelper.isNullOrEmpty(selectedAlarmDef.name.trim())) {
                ToastHelper.showError(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AlarmDefNameError, { collection: 'Popup' }))
            } else {
                const existingTemplates: GoAlarmDef[] = this.templateAlarmDefs.filter((template: GoAlarmDef) => template.name.toLowerCase() == selectedAlarmDef.name.toLowerCase())

                if (existingTemplates.length > 0) {
                    const selectedTemplate = existingTemplates[0]

                    this.addAlarmDefFromTemplate(selectedTemplate)

                    selectedTemplate.visible = false
                } else {
                    const newAlarmDef: GoAlarmDef = new GoAlarmDef(new OpAlarmDef(null))
                    newAlarmDef.alarmDef.isEnabled = false
                    newAlarmDef.alarmDef.visible = true
                    newAlarmDef.name = selectedAlarmDef.name
                    newAlarmDef.visible = true

                    this.addNewAlarmDef(newAlarmDef)
                }
            }

        })

        this.clearNewAlarmDefCustomNames()

        this.setButtonsStates()
    }

    private onAddAlarmDefClick(args: any): void {
        this.alarmDefPopoverTagBoxOptions.innerOptions.dataSource = [].concat(this.templateAlarmDefs || [])
        this.alarmDefPopoverVisible = true
    }

    //#endregion

    // #region Flags   

    protected areAlarmDefsLoaded(alarmDef: GoAlarmDef): boolean {
        return this.alarmTypes != null
            && alarmDef != null
            && alarmDef.alarmDef != null
    }

    protected isAlarmDefCustomDataVisible(): boolean {
        return this.currentAlarmDefExists()
            && this.currentAlarmDefs.some((alarmDef: GoAlarmDef) => alarmDef.opState == Enums.OpChangeState.New && !alarmDef.isTemplate)
    }

    protected isAlarmDefReferenceValueTypeVisible(): boolean {
        return this.alarmDefRefParams != null
            && this.alarmDefRefParams.length > 0
    }

    protected areReferenceTypeColumnsVisible(): boolean {
        return this.currentAlarmDefExists()
            && this.currentAlarmDefs.length > 0
            && this.currentAlarmDefs.some((alarmDef: GoAlarmDef) => alarmDef.alarmDef.visible)
    }

    private currentAlarmDefExists(): boolean {
        return this.currentAlarmDefs != null
    }

    //#endregion

    protected createAlarmDefOptions(alarmDef: GoAlarmDef): AlarmDefinitionItemEditOptions {
        return {
            alarmDef: alarmDef,
            alarmDefParams: this.alarmDefParamsColumns,
            alarmDefRefParams: this.alarmDefRefParams,
            dataTypes: this.dataTypes,
            alarmTypes: this.alarmTypes,
            onInitialized: (controller: IAlarmDefinitionItemEdit) => { this.updateAlarmDefItemEditControllers(controller) },
            alarmDefUpdated: (alarmDef: GoAlarmDef) => { this.onAlarmDefUpdated(alarmDef) }
        }
    }

    protected updateAlarmDefItemEditControllers(newController: IAlarmDefinitionItemEdit = null): void {
        this.alarmDefItemEditControllers = this.alarmDefItemEditControllers || []

        if (newController != null) {
            this.alarmDefItemEditControllers.push(newController)
        }

        this.alarmDefItemEditControllers.forEach((controller: IAlarmDefinitionItemEdit) => {
            controller.setAlarmDefCustomDataVisible(this.isAlarmDefCustomDataVisible())
        })
    }

    protected deleteAlarmDef(alarmDef: GoAlarmDef): void {
        const goAlarmDefToDelete: GoAlarmDef = _.find(this.currentAlarmDefs, (goAlarmDef: GoAlarmDef) => goAlarmDef == alarmDef)

        if (goAlarmDefToDelete != null) {
            const templateAlarmDef: GoAlarmDef = _.find(this.templateAlarmDefs, (template: GoAlarmDef) => template.name.toLowerCase() == alarmDef.name.toLowerCase())
            if (templateAlarmDef != null) {
                templateAlarmDef.visible = true
            }

            let idx: number = this.currentAlarmDefs.indexOf(goAlarmDefToDelete)

            if (idx >= 0) {
                this.currentAlarmDefs.splice(idx, 1)

                const alarmDefOptions: AlarmDefinitionItemEditOptions = _.find(this.alarmDefsOptions, (opts: AlarmDefinitionItemEditOptions) => opts.alarmDef == alarmDef)

                idx = this.alarmDefsOptions.indexOf(alarmDefOptions)
                if (idx >= 0) {
                    this.alarmDefsOptions.splice(idx, 1)
                } else {
                    LogHelper.error(AlarmDefinitionService.LOG_PREFIX, 'Tried to remove options of new, unsaved alarm def but it does not exist in currentAlarmDefs collection. Control state is invalid.')
                }

                const alarmGroupRowOptions: IAlarmDefinitionGroupRowEditOptions = _.find(this.alarmGroupEditOptions, (opts: IAlarmDefinitionGroupRowEditOptions) => opts.alarmDef == alarmDef.alarmDef)

                idx = this.alarmGroupEditOptions.indexOf(alarmGroupRowOptions)
                if (idx >= 0) {
                    this.alarmGroupEditOptions.splice(idx, 1)
                } else {
                    LogHelper.error(AlarmDefinitionService.LOG_PREFIX, 'Tried to remove group options of new, unsaved alarm def but it does not exist in currentAlarmDefs collection. Control state is invalid.')
                }

                this.updateAlarmDefItemEditControllers()
            } else {
                LogHelper.error(AlarmDefinitionService.LOG_PREFIX, 'Tried to remove new, unsaved alarm def but it does not exist in currentAlarmDefs collection. Object state is invalid.')
            }
        } else {
            LogHelper.error(AlarmDefinitionService.LOG_PREFIX, 'Tried to remove GoAlarmDef instance of new, unsaved alarm def but it does not exist in currentAlarmDefs collection. Control state is invalid.')
        }
    }

    protected setAlarmDefChangeState(alarmDef: OpAlarmDef): void {
        if (alarmDef == null) {
            return
        }

        if (alarmDef.idAlarmDef == 0) {
            alarmDef.opState = Enums.OpChangeState.New
        } else {
            alarmDef.opState = Enums.OpChangeState.Modified
        }
    }

    protected clearNewAlarmDefCustomNames(): void {
        this.alarmDefPopoverVisible = false
        this.selectedAlarmDefs = []
    }

    protected addAlarmDefFromTemplate(template: GoAlarmDef): void {
        const newAlarmDef: GoAlarmDef = template.clone(true, true, true, true)

        newAlarmDef.isTemplate = true

        this.addNewAlarmDef(template)
    }

    protected addNewAlarmDef(alarmDef: GoAlarmDef): void {
        if (alarmDef == null) { return }

        if (alarmDef.alarmDef.currentAlarmDefGroups == null) {
            alarmDef.alarmDef.currentAlarmDefGroups = []
        }

        if (this.currentAlarmGroups == null) {
            this.currentAlarmGroups = []
        }

        const alarmDefGroups: OpAlarmDefGroup[] = []

        this.currentAlarmGroups.forEach((alarmGroup: OpAlarmGroup) => {
            this.alarmDefinitionService
                .getSupportedTransmissionTypes()
                .forEach((transmissionType: Enums.TransmissionType) => {
                    const alarmDefGroup: OpAlarmDefGroup = new OpAlarmDefGroup(null)

                    alarmDefGroup.idAlarmDef = alarmDef.idAlarmDef
                    alarmDefGroup.idAlarmGroup = alarmGroup.idAlarmGroup
                    alarmDefGroup.idTransmissionType = <number>transmissionType

                    alarmDefGroup.alarmDef = alarmDef.alarmDef
                    alarmDefGroup.alarmGroup = alarmGroup

                    alarmDefGroups.push(alarmDefGroup)
                })
        })

        alarmDef.opState = Enums.OpChangeState.New

        const alarmDefOptions: AlarmDefinitionItemEditOptions = this.createAlarmDefOptions(alarmDef)

        this.currentAlarmDefs.push(alarmDef)
        this.alarmDefsOptions.push(alarmDefOptions)

        this.alarmGroupEditOptions.push(this.createAlarmGroupRowEditOptions(alarmDef.alarmDef))
    }

    //#region TagBox

    public alarmDefPopoverTagBoxOptions: IMRTagBoxOptions<GoAlarmDef>

    private initializeAlarmDefTagBox(): void {
        this.alarmDefPopoverTagBoxOptions = {
            innerOptions: {
                acceptCustomValue: this.alarmDefParamsExist,
                applyValueMode: 'useButtons',
                displayExpr: 'name',
                valueExpr: 'alarmDef',
                noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
                placeholder: TypeHelper.emptyString,
                hideSelectedItems: false,
                showSelectionControls: true,

                height: 36,

                onCustomItemCreating: (args: any) => { return this.onAlarmDefPopoverInputTagBoxCustomItemCreating(args) },
                onValueChanged: (args: any) => { this.onAlarmDefPopoverInputTagBoxValueChanged(args) },
            },

            dropDownButtonDirection: IMRTagBoxDropDownDirection.Up,
            saveOnBlur: true,
            showDropDownButton: true,
            showScrollBar: true,
        }
    }

    protected setAlarmDefTagBoxAcceptCustomValues(isAcceptCustomValue: boolean): void {
        this.alarmDefPopoverTagBoxOptions.innerOptions.acceptCustomValue = isAcceptCustomValue
    }

    //#endregion
}